
import { Navigate } from "react-router-dom";

export default function HomeIndex(){
  
  return  <Navigate to="/dashboard" replace />;
}